export default __webpack_public_path__ + "static/media/b09.9b5f13c3.jpg";